import BlackFridayLanding from 'components/pages/Landing/BlackFriday';

import { resolvify } from 'lib/promises';

import { getTopbarAd } from 'services/ads';
import { getCategoriesList } from 'services/category';
import { getCouponFeaturedStoresList } from 'services/coupon';
import {
  getLandingInfo,
  getLandingOffersList,
  getLandingsList,
} from 'services/landing';
import { getStoresList } from 'services/store';

import APP from 'constants/app';
import LANDINGS from 'constants/landings';
import LINKS from 'constants/links';

const BLACK_FRIDAY_API_PARAM = 'black-friday';

const BlackFriday = (props) => (
  <BlackFridayLanding
    offersListProps={{ showButtonBeforeFirstPagination: true }}
    {...props}
  />
);

export const getServerSideProps = async () => {
  try {
    const [
      { landing },
      initialOffers,
      storesWithFeaturedCoupons,
      categories,
      stores,
      featuredLandings,
      highlightedLandings,
      topbarAd,
    ] = await resolvify([
      getLandingInfo({ landingSlug: BLACK_FRIDAY_API_PARAM }),
      getLandingOffersList({
        landingSlug: BLACK_FRIDAY_API_PARAM,
        limit: LANDINGS.OFFERS_SERVER_LIMIT,
      }),
      {
        fn: getCouponFeaturedStoresList(),
        fallback: getCouponFeaturedStoresList.fallback,
      },
      {
        fn: getCategoriesList({ selectedCategories: true }),
        fallback: getCategoriesList.fallback,
      },
      {
        fn: getStoresList({ from: 'topbar' }),
        fallback: getStoresList.fallback,
      },
      {
        fn: getLandingsList({ featured: true }),
        fallback: getLandingsList.fallback,
      },
      {
        fn: getLandingsList({ highlighted: true }),
        fallback: getLandingsList.fallback,
      },
      { fn: getTopbarAd(), fallback: getTopbarAd.fallback },
    ]);

    if (landing.landingType !== LANDINGS.TYPES.BLACK_FRIDAY) {
      return { redirect: { destination: LINKS[404], permanent: false } };
    }

    return {
      props: {
        initialOffers,
        landing,
        storesWithFeaturedCoupons,
        [APP.CTX_OPTIONAL_PROPS]: {
          categories,
          featuredLandings,
          highlightedLandings,
          stores,
          topbarAd,
        },
      },
    };
  } catch {
    return { redirect: { destination: LINKS[404], permanent: false } };
  }
};

export default BlackFriday;
